export const formatSentenceWithAVsAn = sentence => {
  const wordList = sentence.split(' ');
  const vowels = ['a', 'e', 'i', 'o', 'u', 'A', 'E', 'I', 'O', 'U'];

  wordList.map((word, i, arr) => {
    if (word === 'a' || word === 'an') {
      if (vowels.some(vowel => wordList[i + 1].startsWith(vowel))) {
        arr[i] = 'an';
      } else {
        arr[i] = 'a';
      }
    }
    return wordList;
  });
  const formattedSentence = wordList.join(' ');
  return formattedSentence;
};
